import { DISPLAY_MONTH_NAMES, type MonthYear } from '@/lib/payments';

/**
 * Policies and loans use month keys in the form 'YYYY-MM' (e.g. '2026-10').
 * These helpers convert and format them.
 */

export const toMonthKey = ({ month, year }: MonthYear): string =>
  `${year}-${String(month + 1).padStart(2, '0')}`;

export const fromMonthKey = (key: string): MonthYear => {
  const [year, month] = key.split('-').map(Number);
  return { year, month: month - 1 };
};

export const currentMonthKey = (): string => {
  const now = new Date();
  return toMonthKey({ month: now.getMonth(), year: now.getFullYear() });
};

export const addMonthsToKey = (key: string, months: number): string => {
  const { year, month } = fromMonthKey(key);
  const total = year * 12 + month + months;
  return toMonthKey({ year: Math.floor(total / 12), month: total % 12 });
};

/** 'YYYY-MM' → 'Oct 2026'. Returns '--' for an empty value. */
export const formatMonthKey = (key?: string | null): string => {
  if (!key) return '--';
  const { year, month } = fromMonthKey(key.slice(0, 7));
  return `${DISPLAY_MONTH_NAMES[month]} ${year}`;
};

/** 'YYYY-MM' → 'Oct'. */
export const formatShortMonth = (key?: string | null): string =>
  key ? DISPLAY_MONTH_NAMES[fromMonthKey(key.slice(0, 7)).month] : '--';

/** 'YYYY-MM' → "Oct '26", used on chart axes. */
export const formatChartMonth = (key: string): string => `${formatShortMonth(key)} '${key.slice(2, 4)}`;
